<div class="ntux-delete-btn">
  <a
    class="ntux-delete-btn__main"
    [class.ntux-delete-btn--activated]="activated"
    (click)="onDeleteClick()"
    role="button"
    tabindex="0"
    (keydown.enter)="onDeleteClick()"
    (keydown.space)="onDeleteClick()">
    Delete
  </a>
  <div
    class="ntux-delete-btn-confirmation"
    [class.ntux-delete-btn--activated]="activated">
    <div class="ntux-delete-btn-confirmation__label">Are you sure?</div>
    <div>
      <a
        class="ntux-delete-btn-confirmation__no"
        (click)="onCancelClick()"
        role="button"
        tabindex="0"
        (keydown.enter)="onCancelClick()"
        (keydown.space)="onCancelClick()">
        No
      </a>
    </div>
    <div>
      <a
        class="ntux-delete-btn-confirmation__yes"
        (click)="onConfirmClick()"
        role="button"
        tabindex="0"
        (keydown.enter)="onConfirmClick()"
        (keydown.space)="onConfirmClick()">
        Yes, delete
      </a>
    </div>
  </div>
</div>
